export default __webpack_public_path__ + "static/media/stakeholdersSetup.b1f75833.svg";